module.exports = __webpack_public_path__ + "assets/img/remix-icons-fill-design-Vector.5ef1ef0e.svg";